/**
 * Sticky Header
 * Adds a class to header on scroll
 */
import magnificPopup from '../vendors/jquery-magnificpopup';
import organicTabs from '../vendors/organic-tab';
import Swiper from '../vendors/swiper-bundle.min';
import '../vendors/slick.min.js';

jQuery( document ).on( 'scroll', function() {
	if ( jQuery( document ).scrollTop() > 0 ) {
		jQuery( 'header, body' ).addClass( 'shrink' );
	} else {
		jQuery( 'header, body' ).removeClass( 'shrink' );
	}
} );

// Header Section Data Sets
const lastScrollTop = 0,
	delta = 15,
	headerSection = jQuery( '.header-section' ),
	heroFixedVavCtn = jQuery( '.hero-fixed-nav-ctn' ),
	topBar = jQuery( '.top-bar' ),
	navOverlay = jQuery( '.nav-overlay' ),
	body_header = jQuery( 'header,body' );

jQuery.noConflict();

setTimeout( () => {
	const smoothSwiper = new Swiper( '.swiper-container',
		{
			slidesPerView: '1',
			speed: 1500,
			direction: 'horizontal',
			spaceBetween: 25,
			centeredSlides: true,
			loop: true,
			navigation:
				{
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
			pagination:
				{
					el: '.swiper-pagination',
					dynamicBullets: true,
				},

			autoplay:
				{
					delay: 3000,
				},

			breakpoints: {
				// When window width is <= 576px
				576: {
					centeredSlides: false,
					spaceBetween: 10,
				},
				// When window width is <= 768px
				768: {
					spaceBetween: 10,
					centeredSlides: false,
				},
				// When window width is <= 992px
				992: {
					spaceBetween: 25,
				},
			},
		} );
}, 100 );

setTimeout( () => {
	const imageSwiper = new Swiper( '.testimonial-swiper-container',
		{
			slidesPerView: 1,
			speed: 1000,
			spaceBetween: 10,
			centeredSlides: false,
			loop: true,
			autoplay: true,
		} );
}, 500 );

setTimeout( () => {
	if ( jQuery( window ).width() > 918 ) {
		const isatSwiper = new Swiper( '.isat-image-container', {
			direction: 'vertical',
			effect: 'slide',
			slidesPerView: 1,
			speed: 5000,
			spaceBetween: 40,
			loop: true,
			autoplay: {
				delay: 2000,
				reverseDirection: true,
				disableOnInteraction: true,
			},
		// on: {
		// 	slideChangeTransitionStart() {
		// 		// Hide all sub-images when slide transition starts
		// 		const subImages = document.querySelectorAll( '.sub-image' );
		// 		subImages.forEach( ( subImage ) => {
		// 			subImage.style.visibility = 'hidden';
		// 		} );
		// 	},
		// 	slideChangeTransitionEnd() {
		// 		// Show sub-image of the current slide when transition ends
		// 		const currentSlideIndex = this.realIndex;
		// 		const subImages = document.querySelectorAll( '.sub-image' );
		// 		subImages[ currentSlideIndex ].style.visibility = 'visible';
		// 	},
		// },
		} );
	}
}, 100 );

jQuery.noConflict();

adjustHeader();

// Function to handle load event
function handleLoad() {
	adjustTopBar();
}

// Function to handle resize event
function handleResize() {
	// Check if top bar is hidden, if it is, do not show it on resize
	if ( ! jQuery( '.top-bar' ).hasClass( 'hide-top-bar' ) ) {
		adjustTopBar();
	}
}

// Function to handle click event on top bar cross
function handleTopBarCrossClick() {
	hideTopBar();
}

// Function to adjust top bar
function adjustTopBar() {
	// Your existing code to adjust top bar goes here
}

// Function to show top bar
function adjustHeader() {
	const $topBar = jQuery( '.top-bar' );
	const $headerSection = jQuery( '.header-section' );
	const $headerInner = jQuery( '.header-inner' );

	$headerSection.css( 'top', '0' );
	jQuery( '.hero-section' ).css( 'padding-top', $headerSection.outerHeight() + 'px' );
}

// Function to hide top bar
function hideTopBar() {
	const $topBar = jQuery( '.top-bar' );
	const $headerSection = jQuery( '.header-section' );

	$topBar.addClass( 'hide-top-bar' );
	$headerSection.css( 'top', '-' + $topBar.outerHeight() + 'px' );
	jQuery( '.hero-section' ).css( 'padding-top', $headerSection.outerHeight() - $topBar.outerHeight() + 'px' );
}

// Bind load event handler
jQuery( window ).on( 'load', handleLoad );

// Bind resize event handler
jQuery( window ).on( 'resize', handleResize );

// Bind click event handler for top bar cross

jQuery( window ).on( 'load', function() {
	const tabbedItemsHeight = jQuery( '.tabs-links' ).outerHeight();

	jQuery( '.tabs-links' ).height( tabbedItemsHeight + 10 );

	// if (!jQuery('.top-bar').hasClass('hide-top-bar')) {
	const topBar_height = jQuery( '.top-bar' ).outerHeight();
	let logedin_topBar_height = jQuery( '.top-bar' ).outerHeight();
	const $header_height = jQuery( '.header-section' ).outerHeight();
	const $header_inner = jQuery( '.header-inner' ).outerHeight();
	const $wpAdminBar = jQuery( '#wpadminbar' ).outerHeight();
	const $paddingTopValue = jQuery( '.hero--home' ).css( 'padding-top' );

	let adjustment = 0;
	if ( jQuery( 'body' ).hasClass( 'logged-in' ) ) {
		adjustment = 32;
		logedin_topBar_height = topBar_height - adjustment;

		if ( jQuery( window ).width() < 783 ) {
			adjustment = 46;
			logedin_topBar_height = topBar_height - adjustment;
		}
	}

	// Update styles for .hero-section
	jQuery( '.hero-section' ).css( 'padding-top', ( $header_height ) + 'px' );
	jQuery( '.header-section' ).css( 'top', adjustment + 'px' );
	// Update styles for elements with classes .have-topbar and .hide-topbar

	jQuery( '.nav-overlay' ).css( 'padding-top', '0' );

	if ( jQuery( window ).width() < 992 ) {
		jQuery( '.nav-overlay' ).css( 'top', ( adjustment + $header_height ) + 'px' );

		jQuery( '.top-bar-cross' ).on( 'click', function() {
			jQuery( '.nav-overlay' ).css( 'top', ( adjustment ) + 'px' );
		} );
	}

	jQuery( '.top-bar-cross' ).on( 'click', function() {
		jQuery( '.top-bar' ).addClass( 'hide-top-bar' );
		jQuery( '.header-section' ).css( 'top', '-' + ( logedin_topBar_height ) + 'px' );
		jQuery( '.hero-section' ).css( 'padding-top', ( $header_height - topBar_height ) + 'px' );
	} );
} );

/**
 * Document Ready Function
 * Triggered when document get's ready
 */
// jQuery( window ).load( function() {
// 	if ( jQuery( window ).width() < 748 ) {
// 		function moveProjectTag() {
// 			jQuery( '.pp-benefits' ).after( jQuery( '.has-gradient .pricing-plan .wp-block-button' ) );
// 		}
// 		moveProjectTag();
// 		jQuery( window ).resize( moveProjectTag );
// 	}
// } );

jQuery( function() {
	if ( jQuery( window ).width() < 992 ) {
		jQuery( '.iat-container-slider .glide-spacer ' ).remove();
		setTimeout( () => {
			jQuery( '.iat-container-slider' ).slick( {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: false,
				speed: 500,
				dots: false,
				arrows: false,
			} );
		}, 100 );
	}

	/**
	 * Toggle menu for mobile
	 */
	// accessible sub menu
	jQuery( '.menu-item-has-children > a' )
		.focus( function() {
			jQuery( this ).siblings( '.desktop-menu.sub-menu' ).addClass( 'focused' );
		} )
		.blur( function() {
			jQuery( this ).siblings( '.desktop-menu.sub-menu' ).removeClass( 'focused' );
		} );
	// jQuery( '.desktop-menu.sub-menu a' ).focus( function() {
	// 	jQuery( this ).parents( 'ul' ).addClass( 'focused' );
	// } ).blur( function() {
	// 	jQuery( this ).parents( 'ul' ).removeClass( 'focused' );
	// } );

	jQuery( '.menu-btn' ).on( 'click', function() {
		jQuery( this ).toggleClass( 'active' );
		jQuery( '.nav-overlay' ).toggleClass( 'open' );
		jQuery( 'html, body' ).toggleClass( 'no-overflow' );
		jQuery( '.header-nav ul li.active' ).removeClass( 'active' );
		jQuery( '.header-nav ul.sub-menu' ).slideUp();
	} );
	jQuery.noConflict();

	jQuery.noConflict();

	/**
	 * Add span tag to multi-level accordion menu for mobile menus
	 */
	jQuery( 'li' ).each( function() {
		if ( jQuery( this ).hasClass( 'menu-item-has-children' ) ) {
			jQuery( this )
				.find( 'a:first' )
				.after( '<span class="submenu-icon" role="presentation"></span>' );
		}
	} );

	// // Adding custom class when 'menu-link' is focused
	// jQuery( '.menu-link.main-menu-link' ).on( 'keypress', function() {
	// 	const $desktopMenu = jQuery( this ).siblings( '.desktop-menu' );
	// 	// alert( 'clicked' );
	// 	$desktopMenu.addClass( 'accessible-desktop-menu-active' ); // Add custom class when focused
	// 	$desktopMenu.show(); // Show the 'desktop-menu' if hidden
	// } );

	// // Removing custom class when 'menu-link' is not focused (focusout)
	// jQuery( '.menu-link.main-menu-link' ).on( 'focusout', function() {
	// 	const $desktopMenu = jQuery( this ).siblings( '.desktop-menu' );
	// 	setTimeout( function() {
	// 		if ( ! jQuery( '.menu-link.main-menu-link' ).is( ':focus' ) ) {
	// 			$desktopMenu.removeClass( 'accessible-desktop-menu-active' ); // Remove custom class when focus is lost
	// 			$desktopMenu.hide(); // Hide the 'desktop-menu'
	// 		}
	// 	}, 200 ); // Adjust delay if needed for smooth transition
	// } );

	jQuery( document ).ready( function( $ ) {
		// Function to handle keyboard navigation in mega menu
		function setupKeyboardNavigation() {
			// For parent menu items that have children, handle keyboard navigation
			jQuery( '.menu-item-has-children > a' ).on( 'focus', function() {
				// Show the associated mega menu when focused
				jQuery( this ).siblings( '.desktop-menu.sub-menu' ).addClass( 'focused' ).slideDown();
			} ).on( 'blur', function() {
				// Hide the mega menu on blur only if the focus is outside the menu
				const isSubMenuFocused = jQuery( this ).siblings( '.desktop-menu.sub-menu' ).find( 'a:focus' ).length > 0;
				if ( ! isSubMenuFocused ) {
					jQuery( this ).siblings( '.desktop-menu.sub-menu' ).removeClass( 'focused' ).slideUp();
				}
			} );

			// Ensure that the mega menu doesn't close when navigating within it
			jQuery( '.desktop-menu.sub-menu a' ).on( 'focus', function() {
				// Keep the parent menu open when any link within it is focused
				jQuery( this ).parents( '.desktop-menu.sub-menu' ).addClass( 'focused' ).slideDown();
			} ).on( 'blur', function() {
				// Check if focus is outside the mega menu
				const isParentFocused = jQuery( this ).parents( '.desktop-menu.sub-menu' ).find( 'a:focus' ).length > 0;
				if ( ! isParentFocused ) {
					jQuery( this ).parents( '.desktop-menu.sub-menu' ).removeClass( 'focused' ).slideUp();
				}
			} );
		}

		// Call the setupKeyboardNavigation function
		setupKeyboardNavigation();

		// Function to toggle hover-based menu on larger screens
		function toggleMenu() {
			if ( jQuery( window ).width() > 991 ) {
				// Handle hover-based menu opening and closing
				jQuery( 'li.mega-dropdown-menu' ).hover(
					function() {
						jQuery( this ).children( '.desktop-menu' ).slideDown();
					},
					function() {
						jQuery( this ).children( '.desktop-menu' ).slideUp();
					}
				);
			} else {
				// Remove hover effects for smaller screens
				jQuery( 'li.mega-dropdown-menu' ).off( 'mouseenter mouseleave' );
				jQuery( 'li.mega-dropdown-menu .desktop-menu' ).hide();
			}
		}

		// Call toggleMenu for initial setup and on window resize
		toggleMenu();
		jQuery( window ).resize( function() {
			toggleMenu();
		} );
	} );

	if ( jQuery( window ).width() < 992 ) {
	/**
	 * Slide Up/Down internal sub-menu when mobile menu arrow clicked
	 */

		jQuery( document ).on( 'click', '.header-nav .submenu-icon', function() {
			const link = jQuery( this ).closest( 'li' );

			// link.siblings( '.active' ).removeClass( 'active' ).find( 'ul' ).slideUp();

			if ( link.hasClass( 'active' ) ) {
				link.removeClass( 'active' );
				link.find( '.sub-menu' ).slideUp();
			} else {
				link.addClass( 'active' );
				link.find( '.sub-menu' ).slideDown();
			}
		} );

		// Mega Menu Mobile Version
		jQuery( document ).on( 'click', '.header-nav .megamenu-tab-mobile', function() {
			const link = jQuery( this ).siblings( '.megamenu-tabcontent-innerlist-container' );
			jQuery( this ).toggleClass( 'active' );

			if ( link.hasClass( 'active' ) ) {
				link.removeClass( 'active' );
				link.slideUp();
			} else {
				link.addClass( 'active' );
				link.slideDown();
			}
		} );
	}

	/**
	 * Video Magnific Popup
	 */

	 jQuery( document ).ready( function() {
		jQuery( '.is-style-watch-button .wp-block-button__link' ).magnificPopup( {
			type: 'inline',
			midClick: true,
			callbacks: {
				elementParse( item ) {
					const videoSrc = jQuery( item.el ).attr( 'href' );
					item.src = '<div class="popup-inner popup-active" id="video-popup-link" ><video controls playsinline width="100%"> <source src="' + videoSrc + '" type="video/mp4" /></video></div>';
				},
			},
		} );
	} );

	if ( jQuery( '.video-popup' ).length > 0 ) {
		jQuery( '.video-popup' ).magnificPopup( {
			type: 'inline',
			midClick: true,
			fixedContentPos: true,
			overflowY: 'hidden',
			  callbacks: {
				open() {
					// Add your class here
					jQuery( '#video-popup' ).addClass( 'popup-active' );
				},
			 	close() {
					// Pause the video when popup is closed
					const video = jQuery( '#video-popup video' ); // Assuming the video element is nested within #video-popup
					if ( video.length > 0 ) {
						video[ 0 ].pause(); // Accessing the DOM element directly from the jQuery object
					}
				},
			},
		} );
	}

	// jQuery( '.tab-link' ).on( 'click', function( e ) {
	// 	const currentAttrValue = jQuery( this ).attr( 'href' );

	// 	// Show/Hide Tabs
	// 	jQuery( '.tabs-links ' + currentAttrValue ).fadeIn( 400 ).siblings().hide();
	// 	// Change/remove current tab to active
	// 	jQuery( this ).parent( 'li' ).addClass( 'active' ).siblings().removeClass( 'active' );

	// 	e.preventDefault();
	// } );

	// jQuery( '.tabs-links .tab-link' ).click( function() {
	// 	const tab_id = jQuery( this ).attr( 'href' );

	// 	jQuery( '.tabs-links li' ).removeClass( 'current' );
	// 	jQuery( '.tab-content' ).removeClass( 'current' );

	// 	jQuery( this ).addClass( 'current' );
	// 	jQuery( '#' + tab_id ).addClass( 'current' );
	// } );

	// Pricing Table

	if ( jQuery( '.comparison-table' ).length > 0 && jQuery( '.comparison-table' ).hasClass( 'has-connection' ) ) {
		const pricing = [];
		jQuery( '.pricing-plan' ).each( function() {
			const pricingObj = {};
			pricingObj.price = jQuery( this ).find( '.pp-price' ).find( '.pricing-sh.show' ).html().trim();
			pricingObj.buttonText = jQuery( this ).find( '.pricing-sh.show' ).find( 'a' ).text();
			pricingObj.buttonUrl = jQuery( this ).find( '.pricing-sh.show' ).find( 'a' ).attr( 'href' );
			pricing.push( pricingObj );
		} );
		jQuery( '.has-connection' ).find( 'thead' ).find( 'th.has-connection-th' ).each( function( i, v ) {
			jQuery( this ).find( '.tb-price' ).html( pricing[ i ].price );
			jQuery( this ).find( 'a' ).text( pricing[ i ].buttonText );
			jQuery( this ).find( 'a' ).attr( 'href', pricing[ i ].buttonUrl );
		} );
	}
	jQuery( document ).on( 'click', '.pricing-toggle-btn', function() {
		const type = jQuery( this ).attr( 'data-type' );
		jQuery( '.pricing-toggle-btn' ).removeClass( 'active' );
		jQuery( this ).addClass( 'active' );
		jQuery( '.pricing-sh' ).hide();
		jQuery( '.pricing-sh' ).removeClass( 'show' );
		jQuery( '.' + type ).show();
		jQuery( '.' + type ).addClass( 'show' );
		if ( jQuery( '.comparison-table' ).length > 0 && jQuery( '.comparison-table' ).hasClass( 'has-connection' ) ) {
			const pricing = [];
			jQuery( '.pricing-plan' ).each( function() {
				const pricingObj = {};
				pricingObj.price = jQuery( this ).find( '.pp-price' ).find( '.' + type ).html().trim();
				pricingObj.buttonText = jQuery( this ).find( '.' + type ).find( 'a' ).text();
				pricingObj.buttonUrl = jQuery( this ).find( '.' + type ).find( 'a' ).attr( 'href' );
				pricing.push( pricingObj );
			} );
			jQuery( '.has-connection' ).find( 'thead' ).find( 'th.has-connection-th' ).each( function( i, v ) {
				jQuery( this ).find( '.tb-price' ).html( pricing[ i ].price );
				jQuery( this ).find( 'a' ).text( pricing[ i ].buttonText );
				jQuery( this ).find( 'a' ).attr( 'href', pricing[ i ].buttonUrl );
			} );
		}
	} );
	jQuery( document ).on( 'click', '.comparision-button', function() {
		jQuery( this ).toggleClass( 'open' );
		jQuery( '.comparision-table' ).slideToggle();
	} );

	// Organic Tabs

	( function( $ ) {
		$.organicTabs = function( el, options ) {
			const base = this;
			base.$el = jQuery( el );
			base.$nav = base.$el.find( '.nav' );

			base.init = function() {
				base.options = $.extend( {}, $.organicTabs.defaultOptions, options );

				// Accessible hiding fix
				jQuery( '.hide' ).css( {
					position: 'relative',
					top: 0,
					left: 0,
					display: 'none',
				} );

				base.$nav.on( 'click', 'li > a', function() {
					// Figure out current list via CSS class
					const curList = base.$el
							.find( 'a.current' )
							.attr( 'href' )
							.substring( 1 ),
						// List moving to
						$newList = jQuery( this ),
						// Figure out ID of new list
						listID = $newList.attr( 'href' ).substring( 1 ),
						// Set outer wrapper height to (static) height of current inner list
						$allListWrap = base.$el.find( '.list-wrap' ),
						curListHeight = $allListWrap.height();
					$allListWrap.height( curListHeight );

					if ( listID != curList && base.$el.find( ':animated' ).length == 0 ) {
						// Fade out current list
						base.$el.find( '#' + curList ).fadeOut( base.options.speed, function() {
							// Fade in new list on callback
							base.$el.find( '#' + listID ).fadeIn( base.options.speed );

							// Adjust outer wrapper to fit new list snuggly
							const newHeight = base.$el.find( '#' + listID ).height();
							$allListWrap.animate( {
								height: newHeight,
							} );

							// Remove highlighting - Add to just-clicked tab
							base.$el.find( '.nav li a' ).removeClass( 'current' );
							$newList.addClass( 'current' );
						} );
					}

					// Don't behave like a regular link
					// Stop propegation and bubbling
					return false;
				} );
			};
			base.init();
		};

		$.organicTabs.defaultOptions = {
			speed: 300,
		};

		$.fn.organicTabs = function( options ) {
			return this.each( function() {
				new $.organicTabs( this, options );
			} );
		};
	}( jQuery ) );

	jQuery( '#tabs-container' ).organicTabs( {
		speed: 200,
	} );

	/**
	 * Stats
	 */

	jQuery(
		( function( jQuery, win ) {
			jQuery.fn.inViewport = function( cb ) {
				return this.each( function( i, el ) {
					function visPx() {
						const H = jQuery( win ).height(),
							r = el.getBoundingClientRect(),
							t = r.top,
							b = r.bottom;
						const inViewport = t < H && b > 0;
						if ( inViewport ) {
							cb.call( el, H - t );
						}
					}
					visPx();
					jQuery( win ).on( 'resize scroll', visPx );
				} );
			};
		} )( jQuery, window )
	);

	jQuery( '.stat-number' ).inViewport( function( px ) {
		if ( px > 0 && ! this.initNumAnim ) {
			this.initNumAnim = true;
			const $this = jQuery( this ),
				dataNumber = $this.text(); // Use text() instead of html() to get only the text content

			// Extract numeric part from the string using regular expression
			const numericPart = dataNumber.match( /\d+(\.\d+)?/ );
			if ( numericPart ) {
				const rangeStart = parseFloat( numericPart[ 0 ] );
				const rangeEnd = rangeStart; // For single values, start and end are the same
				const startValue = rangeStart / 2;

				jQuery( {
					countNum: startValue,
				} ).animate( {
					countNum: rangeEnd,
				}, {
					duration: 1500,
					easing: 'swing',
					step() {
						if ( Number.isInteger( startValue ) ) {
							$this.text( dataNumber.replace( /\d+(\.\d+)?/, Math.ceil( this.countNum ).toLocaleString( 'en' ) ) );
						} else {
							$this.text( dataNumber.replace( /\d+(\.\d+)?/, this.countNum.toFixed( 1 ).toLocaleString( 'en' ) ) );
						}
					},
					complete() {
						if ( Number.isInteger( this.countNum ) ) {
							$this.text( dataNumber.replace( /\d+(\.\d+)?/, Math.ceil( this.countNum ).toLocaleString( 'en' ) ) );
						} else {
							$this.text( dataNumber.replace( /\d+(\.\d+)?/, this.countNum.toFixed( 1 ).toLocaleString( 'en' ) ) );
						}
					},
				} );
			}
		}
	} );

	function isInt( n ) {
		return Number( n ) === n && n % 1 === 0;
	}

	/**
	 * FAQ Block
	 */
	// Click event handler
	jQuery( '.faq-icon' ).on( 'click', function( event ) {
		const $faqContainer = jQuery( this ).closest( '.faq' );
		const $faqContent = $faqContainer.find( '.faq-content' );

		toggleFaqContent( $faqContent, jQuery( this ) );
	} );

	// Focus event handler
	jQuery( '.faq-icon' ).on( 'focus', function( event ) {
		// Your focus event handling code here
	} );

	// Keypress event handler
	jQuery( '.faq-icon' ).on( 'keypress', function( event ) {
		if ( event.which === 13 || event.which === 32 ) { // Check for Enter key or Spacebar key
			const $faqContainer = jQuery( this ).closest( '.faq' );
			const $faqContent = $faqContainer.find( '.faq-content' );

			toggleFaqContent( $faqContent, jQuery( this ) );
		}
	} );

	function toggleFaqContent( $faqContent, $icon ) {
		if ( $faqContent.is( ':visible' ) ) {
			$faqContent.slideUp( 300 );
			$icon.removeClass( 'active' );
		} else {
			jQuery( '.faq-content' ).slideUp( 300 );
			jQuery( '.faq-icon' ).removeClass( 'active' );
			$faqContent.slideDown( 300 );
			$icon.addClass( 'active' );
		}
	}
} );

jQuery( document ).ready( function() {
	if ( jQuery( window ).width() < 992 ) {
		jQuery( '.pricing-block-ctn' ).each( function() {
			const nav = `<ul class="pricing-plan-tab-links nav"></ul>`;
			jQuery( nav ).insertBefore( jQuery( this ).find( '.pricing-plans' ) );
			jQuery( this ).find( '.pricing-plans' ).find( '.pricing-plan-col' ).each( function( i ) {
				const heading = jQuery( this ).find( '.pp-head h2' ).text();
				let myClass = '';
				if ( i === 0 ) {
					myClass = 'current';
				}
				jQuery( '.pricing-plan-tab-links' ).append( `<li>
							<a href="#` + heading.toLocaleLowerCase() + `" class="tab-link ` + myClass + `">
								<div class="tab-title">
									` + heading.toLowerCase() + `
								</div>
							</a>
						</li>` );
				jQuery( this ).attr( 'id', heading.toLocaleLowerCase() );
				jQuery( this ).addClass( 'pp-column-' + ( parseInt( i ) + 1 ) );
				jQuery( '.comparision-table' ).each( function() {
					const text = jQuery( this ).find( '.cp-column' ).eq( 0 ).find( '.row-label span' ).text();
					const style = jQuery( this ).find( '.pricing-table-three-columns' ).attr( 'style' );
					jQuery( this ).find( '.cp-column' ).eq( i ).addClass( 'cp-column-' + ( parseInt( i ) + 1 ) );
					jQuery( this ).find( '.cp-column' ).eq( i ).find( '.row-label span' ).text( text );
					jQuery( this ).find( '.cp-column' ).eq( i ).attr( 'style', style );
				} );
			} );
		} );

		// Find all unique classes starting with 'cp-column-' within .pricing-block-ctn section
		const columnClasses = jQuery( '.pricing-block-ctn [class^="cp-column"]' ).map( function() {
			return '.' + this.className.match( /(^|)cp-column-\S+/g ).join( '.' );
		} ).get();
		// console.log(columnClasses);

		// Find all unique classes starting with 'pricing-plan-col-' within .pricing-block-ctn section
		const pricingClasses = jQuery( '.pricing-block-ctn [class^="pricing-plan-col"]' ).map( function() {
			return '.' + this.className.match( /(^|)pp-column-\S+/g ).join( '.' );
		} ).get();

		// Loop through each column class
		jQuery( columnClasses ).each( function( index, columnClass ) {
		// Find all elements with current column class within .pricing-block-ctn section
			jQuery( '.pricing-block-ctn' ).find( columnClass ).each( function() {
			// Append each found column to corresponding pricing plan column
				jQuery( pricingClasses[ index ] ).append( jQuery( this ) );
			} );
		} );
	}
	jQuery( '#pricing-tabbed-section-mobile' ).organicTabs( {
		speed: 200,
	} );
} );

